/**
 * Markdown renderer specifically for Search AI.
 * This version removes mailto: links and converts them to plain text.
 */
import createDomPurify from 'dompurify';
import {Remarkable} from 'remarkable-v2';
import {linkify} from 'remarkable-v2/linkify';

const markdownRenderer = new Remarkable('full', {
  html: true,
  linkTarget: '_blank',
}).use(linkify);

// Hook function to set all links to target=_blank
function setLinkTargetBlank(node: Element) {
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener');
  }
}

// Hook function to convert mailto links to plain text
function removeMailtoLinks(node: Element) {
  if (
    node.tagName === 'A' &&
    node.getAttribute('href')?.startsWith('mailto:')
  ) {
    // Replace the anchor element with a text node containing just the text content
    const textNode = document.createTextNode(node.textContent || '');
    node.parentNode?.replaceChild(textNode, node);
  }
}

const DOMPurifyNoMailtoLinks = createDomPurify();
// Apply both hooks: first remove mailto links, then set target for remaining links
DOMPurifyNoMailtoLinks.addHook('afterSanitizeAttributes', removeMailtoLinks);
DOMPurifyNoMailtoLinks.addHook('afterSanitizeAttributes', setLinkTargetBlank);

export function renderMarkdownInlineSearchAI(text: string) {
  const rendered = markdownRenderer.renderInline(text);
  return DOMPurifyNoMailtoLinks.sanitize(rendered);
}

export function renderMarkdownSearchAI(text: string) {
  const rendered = markdownRenderer.render(text);
  return DOMPurifyNoMailtoLinks.sanitize(rendered);
}
